import { Button } from '../../components/Button';
import { RotateCcw } from '../../icons';
import { View } from '../../primitives/View';
import { subTestID } from '../../utils/testId';
import { SurfaceEmptyState } from '../SurfaceEmptyState';
import type { QuizGenerationFailedProps } from './QuizGenerationFailed.types';

/**
 * Shown in place of a question slot that will never fill because its batch
 * failed to generate. A failed batch keeps its places in the quiz, so the
 * learner stops here instead of skipping ahead; Try again refills those same
 * places, and Leave quiz is always available. Out-of-credits runs reach it too,
 * as what remains after the paywall.
 *
 * Labels arrive pre-translated (the DS carries no i18n).
 */
export function QuizGenerationFailed({
  title,
  description,
  leaveLabel,
  onLeave,
  retryLabel,
  onRetry,
  testID,
}: QuizGenerationFailedProps) {
  return (
    <SurfaceEmptyState
      title={title}
      description={description}
      testID={testID}
      action={
        <View className="w-full gap-3">
          <Button
            variant="secondary"
            size="l"
            className="w-full"
            testID={subTestID(testID, 'leave')}
            onPress={onLeave}>
            {leaveLabel}
          </Button>
          {onRetry && (
            <Button
              variant="primary"
              size="l"
              className="w-full"
              leftIcon={RotateCcw}
              testID={subTestID(testID, 'retry')}
              onPress={onRetry}>
              {retryLabel}
            </Button>
          )}
        </View>
      }
    />
  );
}
(QuizGenerationFailed as { displayName?: string }).displayName = 'QuizGenerationFailed';
